<template>
    <div id="detalle">
        <div class="banner">
            <h2>VOLOVANES DE FRUTAS ASADAS</h2>
        </div>
        <div class="inf">
            <div class="btns">
                <div id="btn1" class="btn active" @click="cambio('ingredientes')">INGREDIENTES</div>
                <div id="btn2" class="btn" @click="cambio('elaboracion')">ELABORACIÓN</div>
            </div>
            <div id="bloques">
                <div id="ingredientes">
                    <h2></h2>
                    <ul>
                      <li>4 volovanes</li>
                      <li>1 kiwi</li>
                      <li>4 fresas</li>
                      <li>2 rodajas de piña</li>
                      <li>150 gr de nata</li>
                      <li>2 cucharadas de ron</li>
                      <li>2 cucharadas de azúcar</li>
                      <li>hojas de menta</li>
                    </ul>
                </div>
                <div id="elaboracion">
                    <!-- <h2>Principales elaboracion</h2> -->
                  <ol>
                    <li>Pela la piña y los kiwis y córtalos en trozos de bocado.
                      Lava las fresas, retírales las hojitas y córtalas en cuartos.</li>
                    <li>Colócalas en un recipiente apto para el horno, riégalas con el licor y espolvoréalas con 1 cucharada de azúcar.
                       Ásalas a 180ºC durante 5 minutos. Deja reposar unos minutos.</li>
                    <li>Coloca la nata en un bol con la otra cucharada de azúcar y móntala con una batidora de varillas eléctrica.</li>
                    <li>Reparte la nata y las frutas asadas en los volovanes. Añade el jugo resultante de asar las frutas y decora con una hoja de menta.
                      Sirve los volovanes de frutas asadas.</li>
                  </ol>
                </div>

        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    cambio(active) {
      const btn1 = document.getElementById('btn1');


      const btn2 = document.getElementById('btn2');


      const ingredientes = document.getElementById('ingredientes');


      const elaboracion = document.getElementById('elaboracion');


      ingredientes.style.display = 'none';
      elaboracion.style.display = 'none';

      btn1.className = 'btn';
      btn2.className = 'btn';

      if (active == 'ingredientes') {
        console.log('ingredientes');
        btn1.classList.add('active');
        ingredientes.style.display = 'block';
      } else if (active == 'elaboracion') {
        console.log('elaboracion');
        btn2.classList.add('active');
        elaboracion.style.display = 'block';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#detalle {

  .active {
    background: gray !important;
    display: block;
  }
  .banner {
      height: 50vh;
      background-image: url('../../assets/images/recetas/3-min.jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      h2 {
          position: relative;
          top: 10%;
          color: #fff;
          font-size: 2.2em;
          font-weight: bold;
      }
  }
  .flotante {
      position: relative;
      top: -30vh;
      z-index: 10;

  }
  .inf {
      // position: relative;
      // top: -30vh;
      .btns {
          margin: 2% auto;
          margin-bottom: 4%;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .btn {
            cursor: pointer;
              width: 200px;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 5px 15px;
              color: #fff;
              background-color: green;
              border-radius: 10px;
              padding: 10px 30px;
          }
          .btn:nth-child(5) {
              width: 300px;
          }
      }
      #bloques {
          text-align: justify;

        > div {
            color: gray;
           font-size: 1.3em;
            margin: 0 20%;
            h2 {
              text-align: center;
            }
        }
        #ingredientes {
          display: block;

          h2 {
            text-align: center;
          }
        }
        #elaboracion {
            display: none;
        }
      }
  }
}
</style>
